import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  primary: {
    lighten: '#006AFF',
    default: '#014AC3',
    dim: 'rgba(1,74,195,0.4)',
    mute: 'rgba(1,74,195,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#E5E7E8',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#1CB854',
    default: '#0E8450',
    dim: 'rgba(14,132,80,0.4)',
    mute: 'rgba(14,132,80,0.1)',
  },
  red: {
    lighten: '#E53C43',
    default: '#AF1631',
    dim: 'rgba(175,22,49,0.4)',
    mute: 'rgba(175,22,49,0.1)',
  },
  yellow: {
    lighten: '#FFA02E',
    default: '#B75F17',
    dim: 'rgba(183,95,23,0.4)',
    mute: 'rgba(183,95,23,0.1)',
  },
  blue: {
    lighten: '#5097FE',
    default: '#2880FE',
    dim: 'rgba(40,128,254,0.4)',
    mute: 'rgba(40,128,254,0.1)',
  },
  purple: lightColors.purple,
};

export const LightRipplePrimeTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightRP',

  spacingLayout: 16,
  spacingContent: 8,

  borderRadiusContent: 8,
  borderRadiusButtonDefault: 8,
  borderRadiusButtonSmall: 6,
  borderRadiusButtonTiny: 4,

  backgroundBody: `${colors.gray.main} url(/customers/CapsulesLight.png)`,
  backgroundBodyRepeat: 'repeat',
  backgroundBodySize: '480px 240px',

  backgroundHeader: colors.gray.main,
  borderColorHeader: colors.gray.main,
  backgroundSidebar: colors.gray['010'],
});
